declare global {
  interface Window {
    daum: any;
  }
}
interface setProps {
  setFirAddr?: React.Dispatch<React.SetStateAction<string>>;
  setPostCode?: React.Dispatch<React.SetStateAction<string>>;
  setDetail?: React.Dispatch<React.SetStateAction<string>>;
}
interface IAddr {
  address: string;
  zonecode: string;
  needReturn?: true;
}

const SearchAddrApi = (
  props: setProps
): Promise<{ addr_num: string; addr_basic: string }> => {
  const { setFirAddr, setPostCode, setDetail } = props;

  return new Promise((resolve) => {
    new window.daum.Postcode({
      oncomplete: function (data: IAddr) {
        if (setFirAddr) setFirAddr(data.address);
        if (setPostCode) setPostCode(data.zonecode);
        if (setDetail) setDetail("");

        const addr_num = data.zonecode;
        const addr_basic = data.address;
        resolve({ addr_num, addr_basic });
      },
    }).open();
  });
};

export default SearchAddrApi;
